import { UsuarioService } from '../../services/usuario.service';
var OlvidePasswordComponent = /** @class */ (function () {
    function OlvidePasswordComponent(usuarioService) {
        this.usuarioService = usuarioService;
        this.usuario = {
            password: null,
            username: null
        };
        this.alert = {
            tipo: "success",
            titulo: "",
            mensaje: "",
            visible: false
        };
        this.errores = [];
    }
    OlvidePasswordComponent.prototype.ngOnInit = function () {
    };
    OlvidePasswordComponent.prototype.recuperar = function () {
        var _this = this;
        this.alert.visible = false;
        this.usuarioService.recuperarContraseña(this.usuario.username)
            .map(function (result) {
            _this.alert.visible = true;
            _this.alert.titulo = "Recuperar Contraseña";
            if (result.status == 201) {
                _this.alert.tipo = "success";
                _this.alert.mensaje = "Hemos enviado un correo con los pasos a seguir para recuperar su contraseña. Por favor verifique su email.";
            }
            else {
                _this.alert.tipo = "danger";
                _this.alert.mensaje = "No hemos podido enviar el correo con las instrucciones para recuperar su contraseña. Por favor vuelva a intentarlo.";
            }
            _this.alertComponent.setType(_this.alert.tipo);
        })
            .subscribe(function (data) {
        }, function (error) {
            var json = error.json();
            _this.alert.visible = true;
            _this.alert.titulo = "Recuperar Contraseña";
            _this.alert.tipo = "danger";
            _this.alertComponent.setType(_this.alert.tipo);
            _this.alert.mensaje = "No hemos podido enviar el correo con las instrucciones para recuperar su contraseña. Por favor vuelva a intentarlo.";
            if (json.modelState) {
                for (var key in json.modelState) {
                    if (json.modelState[key].length == 1) {
                        _this.errores.push(json.modelState[key]);
                    }
                    else {
                        for (var i = 0; i < json.modelState[key].length; i++) {
                            _this.errores.push(json.modelState[key][i]);
                        }
                    }
                }
            }
        });
    };
    OlvidePasswordComponent.ctorParameters = function () { return [{ type: UsuarioService }]; };
    return OlvidePasswordComponent;
}());
export { OlvidePasswordComponent };
//# sourceMappingURL=olvide-password.component.js.map


// WEBPACK FOOTER //
// olvide-password.component.js